import { axiosInstance } from '.'
import {
  SECONDARY_MARKET_BUY_INTEREST,
  SECONDARY_MARKET_CANCEL_ORDER,
  SECONDARY_MARKET_PORTAL,
  SECONDARY_MARKET_SELL,
} from './endpoints'

export type SecondaryMarketPortalData = {
  settings: {
    is_open: boolean
    window_label: string | null
    closes_at: string | null
  }
  listings: SecondaryMarketOrder[]
  myOrders: SecondaryMarketOrder[]
  trades: SecondaryMarketOrder[]
  eligibleHoldings: Array<{
    opportunity_id: number
    opportunity_title: string
    available_quantity: number
  }>
}

export type SecondaryMarketOrder = {
  id: number
  order_id: string
  type: 'SELL' | 'BUY_INTEREST'
  opportunity_id: number
  opportunity_title?: string
  quantity: number
  price_basis: string
  limit_price: number | null
  reference_price: number | null
  status: string
  agreed_unit_price: number | null
  settlement_status: string | null
  counterparty_order_ref?: string
  window_label: string | null
  metadata?: Record<string, unknown> | null
  created_at: string
}

export const secondaryMarketServices = {
  getPortal: async (): Promise<SecondaryMarketPortalData | null> => {
    const { data, status } = await axiosInstance.get(SECONDARY_MARKET_PORTAL)
    if (status !== 200) return null
    return data as SecondaryMarketPortalData
  },

  submitSell: async (payload: {
    opportunity_id: number
    quantity: number
    price_basis: 'AT_REFERENCE' | 'LIMIT'
    limit_price?: number
  }) => {
    const { data, status } = await axiosInstance.post(SECONDARY_MARKET_SELL, payload)
    return { data, status }
  },

  submitBuyInterest: async (payload: {
    sell_order_id: number
    quantity: number
    offer_price: number
  }) => {
    const { data, status } = await axiosInstance.post(SECONDARY_MARKET_BUY_INTEREST, payload)
    return { data, status }
  },

  cancelOrder: async (orderId: number) => {
    const { data, status } = await axiosInstance.patch(SECONDARY_MARKET_CANCEL_ORDER(orderId))
    return { data, status }
  },
}
